import switchFunc from 'lib/function/switchFunc'

import LineBanIcon from 'components/Luxkit/Icons/line/LineBanIcon'
import LineCalendarIcon from 'components/Luxkit/Icons/line/LineCalendarIcon'
import LineDollarSignAltIcon from 'components/Luxkit/Icons/line/LineDollarSignAltIcon'
import LineFileMinusAltIcon from 'components/Luxkit/Icons/line/LineFileMinusAltIcon'
import LineHeartPlusIcon from 'components/Luxkit/Icons/line/LineHeartPlusIcon'
import LineFilePlusAltIcon from 'components/Luxkit/Icons/line/LineFilePlusAltIcon'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import LineRestaurantIcon from 'components/Luxkit/Icons/line/LineRestaurantIcon'
import LineRefreshIcon from 'components/Luxkit/Icons/line/LineRefreshIcon'
import LineSyringeIcon from 'components/Luxkit/Icons/line/LineSyringeIcon'
import LineBusIcon from 'components/Luxkit/Icons/line/LineBusIcon'
import LineAwardIcon from 'components/Luxkit/Icons/line/LineAwardIcon'
import LineBedIcon from 'components/Luxkit/Icons/line/LineBedIcon'
import LineShieldCheckIcon from 'components/Luxkit/Icons/line/LineShieldCheckIcon'
import LineUsersAltIcon from 'components/Luxkit/Icons/line/LineUsersAltIcon'
import LineFileCheckAltIcon from 'components/Luxkit/Icons/line/LineFileCheckAltIcon'
import LineBackpackIcon from 'components/Luxkit/Icons/line/LineBackpackIcon'
import LineQuestionCircleIcon from 'components/Luxkit/Icons/line/LineQuestionCircleIcon'
import LineShipIcon from 'components/Luxkit/Icons/line/LineShipIcon'

const CRUISE_FINE_PRINT_SECTION_ICONS: Record<App.CruiseFinePrintSection['title'], (props: any) => React.ReactElement> = {
  '7-Day Change of Mind ‘No Questions Asked’ Refund Guarantee': LineRefreshIcon,
  'Covid-19 Related Cancellations': LineBanIcon,
  'Date Changes': LineCalendarIcon,
  Inclusions: LineFilePlusAltIcon,
  Transfers: LineBusIcon,
  Exclusions: LineFileMinusAltIcon,
  'Health & Vaccinations': LineSyringeIcon,
  'Fitness Requirements': LineHeartPlusIcon,
  'Dietary Requirements': LineRestaurantIcon,
  Surcharges: LineDollarSignAltIcon,
}

export const getFinePrintSectionIcon = switchFunc(CRUISE_FINE_PRINT_SECTION_ICONS, LineInfoCircleIcon)

const CRUISE_FAQ_ITEM_ICONS: Record<string, (props: any) => React.ReactElement> = {
  'The vendor': LineShipIcon,
  'The operator': LineAwardIcon,
  'The accommodation': LineBedIcon,
  'The differences': LineQuestionCircleIcon,
  'The experience': LineFileCheckAltIcon,
  'The service': LineShieldCheckIcon,
  'The group': LineUsersAltIcon,
  'The belongings': LineBackpackIcon,
  'The Vaccine': LineSyringeIcon,
  'The terms': LineFileCheckAltIcon,
}

export const getFAQItemIcon = switchFunc(CRUISE_FAQ_ITEM_ICONS, LineInfoCircleIcon)
